"use client";
import { ReactNode, createContext, useContext, useState } from "react";

interface HeaderContextValue {
  setHeaderRender: (fn: ReactNode | undefined) => void;
  headerRender?: ReactNode;
}
const HeaderContext = createContext<HeaderContextValue | null>(null);

export function HeaderContextProvider(props: { children: ReactNode }) {
  const [header, setHeader] = useState<ReactNode | undefined>();
  return (
    <HeaderContext.Provider
      value={{
        headerRender: header,
        setHeaderRender: setHeader,
      }}
    >
      {props.children}
    </HeaderContext.Provider>
  );
}

export function useHeaderContext() {
  const context = useContext(HeaderContext);
  if (context == null) {
    throw new Error("Header context provider not initialised");
  }
  return context;
}
